import * as React from 'react';

import { LogoTheme } from '../../enums';

import LogoFile from './images/logo.svg';
import SymbolFile from './images/symbol.svg';
import WhiteLogoFile from './images/whiteLogo.svg';
import { LogoItem, LogoItemSymbol } from './logo.styled';
import { LogoProps } from './logo.types';

export const Logo: React.FC<LogoProps> = (props: LogoProps) => {
  const { logoTheme = LogoTheme.Classic, className }: LogoProps = props;

  switch (logoTheme) {
    case LogoTheme.White:
      return (
        <LogoItem className={className} src={WhiteLogoFile} alt='on*arte' data-testid='logo-white' />
      );
    case LogoTheme.OnlySymbol:
      return (
        <LogoItemSymbol className={className} src={SymbolFile} alt='on*arte' data-testid='logo-symbol' />
      );
    case LogoTheme.Classic:
    default:
      return (
        <LogoItem className={className} src={LogoFile} alt='on*arte' data-testid='logo-classic' />
      );
  }
};
